module.exports = __webpack_public_path__ + "static/media/minus_black.10f9774d.svg";